import { render, staticRenderFns } from "./view-tests.vue?vue&type=template&id=11ea97e4&"
import script from "./view-tests.vue?vue&type=script&lang=js&"
export * from "./view-tests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports